<template>
  <footer class="mt-5" style="background-color: #dbd5d5">
    <!-- Copyright Section -->
    <div class="text-center py-3">
      <p class="mb-0">© 2026 Sehrish Mart. All Rights Reserved.</p>
    </div>
  </footer>
</template>

<script>
export default {
  name: "FooterComponent",
};
</script>

<style scoped>
footer {
  /* position: relative; */
  width: 100%;
}
</style>
